import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import Auth0ProviderWrapper from './components/Auth/Auth0Provider.tsx'
import AuthGuard from './components/Auth/AuthGuard.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0ProviderWrapper>
      <AuthGuard>
        <App />
      </AuthGuard>
    </Auth0ProviderWrapper>
  </StrictMode>,
)
